import React from "react";
import { ListFilter, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

let cache = { raw: null, set: null };
export const parseClickIds = (raw) => {
  if (!raw || !raw.trim()) return null;
  if (cache.raw !== raw) {
    cache = { raw, set: new Set(raw.split(/[\s,;]+/).map((x) => x.trim().toLowerCase()).filter(Boolean)) };
  }
  return cache.set.size ? cache.set : null;
};

let ocache = { raw: null, set: null };
export const parseOrderIds = (raw) => {
  if (!raw || !raw.trim()) return null;
  if (ocache.raw !== raw) {
    ocache = { raw, set: new Set(raw.split(/[\s,;]+/).map((x) => x.trim().toUpperCase()).filter(Boolean)) };
  }
  return ocache.set.size ? ocache.set : null;
};

export function ClickIdListFilter({ value, onChange, testId = "clickids-filter",
  label = "Click IDs", title = "Filter by System ID (Click ID)", parse = parseClickIds }) {
  const count = parse(value)?.size || 0;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid={testId} data-enter-submit=""
          className={`inline-flex h-9 items-center gap-1.5 rounded-lg border px-3 text-sm outline-none transition-colors ${count
            ? "border-white/25 bg-white/[0.06] text-foreground"
            : "border-white/[0.1] bg-[#0A0A0A] text-muted-foreground hover:border-white/20"}`}>
          <ListFilter className="h-3.5 w-3.5" />
          {label}{count ? ` (${count})` : ""}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-[300px] border-white/[0.1] bg-[#1a1a1e] p-3">
        <p className="mb-1.5 text-xs font-medium text-foreground">{title}</p>
        <Textarea value={value || ""} onChange={(e) => onChange(e.target.value)} rows={7}
          placeholder={"Paste IDs — one per line\n5f3a1b…\n9c04d2…"} data-testid={`${testId}-textarea`}
          className="min-h-[130px] resize-y border-white/[0.12] bg-[#0A0A0A] font-mono text-xs" />
        <div className="mt-2 flex items-center justify-between">
          <span className="text-[11px] text-muted-foreground">{count ? `${count} ID(s) — press Apply` : "Works together with other filters"}</span>
          {count > 0 && (
            <Button size="sm" variant="ghost" onClick={() => onChange("")} data-testid={`${testId}-clear`}
              className="h-7 gap-1 px-2 text-xs text-muted-foreground hover:text-foreground">
              <X className="h-3 w-3" /> Clear
            </Button>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
